import React, { useState, useEffect } from "react";

// core components
import Button from "components/CustomButtons/Button.js";
import Modal from "components/Modal/Modal.js";
import CCchargeForm from "components/CCchargeForm/CCchargeForm";
import ActionAlerts, { AlertSeverity } from "components/ActionAlerts/ActionAlerts";

const SUCCESS_MSG = "Extra charge applied successfully";

export default function CCcharge({ formik, isLocked = false }) {
    const [notification, setNotification] = useState({
        duration: 1000000,
        open: false,
        severity: AlertSeverity.SUCCESS,
        message: SUCCESS_MSG,
    });
    const [openModal, setOpenModal] = useState(false);
    const billingInfo = {
        dealerId: formik.values.dealerId,
        cId: formik.values.customerId,
        billCompany: formik.values.billCompany,
        billAddress1: formik.values.billAddress1,
        billCity: formik.values.billCity,
        billState: formik.values.billState,
        billZip: formik.values.billZip,
        billCountry: formik.values.billCountry,
    };
    const orderReference = formik.values.orderNumber || formik.values.id;

    useEffect(() => {
        return () => {
            setNotification({
                duration: 1000000,
                open: false,
                severity: AlertSeverity.SUCCESS,
                message: SUCCESS_MSG,
            });
        };
    }, [openModal]);

    return (
        <>
            <Modal
                open={openModal}
                maxWidth="sm"
                modalTitle={orderReference ? `Order #${orderReference}` : "Order"}
                plainHeader
                handleClose={() => {
                    setOpenModal(false);
                }}
            >
                {openModal ? (
                    <>
                        {notification.open && (
                            <ActionAlerts
                                message={notification.message}
                                severity={notification.severity}
                                autoCloseTime={null}
                                onClose={() => setNotification({ ...notification, open: false })}
                            />
                        )}

                        <CCchargeForm
                            dealerId={formik.values.dealerId}
                            customerId={formik.values.customerId}
                            orderId={formik.values.id}
                            orderNumber={formik.values.orderNumber}
                            fullAmount={formik.values.orderAmount}
                            pgatewayId={formik.values.pgatewayId}
                            pgatewayCode={formik.values.pgatewayCode}
                            billingInfo={billingInfo}
                            onSuccess={(message) =>
                                setNotification({
                                    ...notification,
                                    open: true,
                                    severity: AlertSeverity.SUCCESS,
                                    message,
                                })
                            }
                            onError={(message) =>
                                setNotification({
                                    ...notification,
                                    open: true,
                                    severity: AlertSeverity.ERROR,
                                    message,
                                })
                            }
                            onCancel={() => setOpenModal(false)}
                        />
                    </>
                ) : null}
            </Modal>

            <Button
                type="button"
                color="linkedin"
                onClick={() => setOpenModal(true)}
                disabled={isLocked}
            >
                Extra charge
            </Button>
        </>
    );
}
